export default __webpack_public_path__ + "static/media/Metal Punk.853db2ca.gif";